/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxDateTimeInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxdatetimeinput';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcDateTimeInputComponent),
    multi: true
};

/**
 * Date Time Input
 */
@Component({
    selector: 'ngc-datetimeinput',
    template: `<jqxDateTimeInput *ngIf="visible" (onChange)="inputChange($event)"
                [animationType] = "animationType"
                [allowNullDate] = "allowNullDate"
                [allowKeyboardDelete] = "allowKeyboardDelete"
                [clearString] = "clearString"
                [culture] = "culture"
                [closeDelay] = "closeDelay"
                [closeCalendarAfterSelection] = "closeCalendarAfterSelection"
                [dropDownHorizontalAlignment] = "dropDownHorizontalAlignment"
                [dropDownVerticalAlignment] = "dropDownVerticalAlignment"
                [disabled] = "disabled"
                [enableBrowserBoundsDetection] = "enableBrowserBoundsDetection"
                [enableAbsoluteSelection] = "enableAbsoluteSelection"
                [firstDayOfWeek] = "firstDayOfWeek"
                [formatString] = "formatString"
                [min] = "min"
                [max] = "max"
                [openDelay] = "openDelay"
                [placeHolder] = "placeHolder"
                [popupZIndex] = "popupZIndex"
                [rtl] = "rtl"
                [readonly] = "readonly"
                [showFooter] = "showFooter"
                [selectionMode] = "selectionMode"
                [showWeekNumbers] = "showWeekNumbers"
                [showTimeButton] = "showTimeButton"
                [showCalendarButton] = "showCalendarButton"
                [theme] = "theme"
                [template] = "template"
                [textAlign] = "textAlign"
                [todayString] = "todayString"
                [value] = "value"
                [width] = "width"
                [height] = "height">
                </jqxDateTimeInput>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcDateTimeInputComponent extends ControlComponent {
    @Input('animationType') animationType: any;
    @Input('allowNullDate') allowNullDate: any;
    @Input('allowKeyboardDelete') allowKeyboardDelete: any;
    @Input('clearString') clearString: any;
    @Input('culture') culture: any;
    @Input('closeDelay') closeDelay: any;
    @Input('closeCalendarAfterSelection') closeCalendarAfterSelection: any;
    @Input('dropDownHorizontalAlignment') dropDownHorizontalAlignment: any;
    @Input('dropDownVerticalAlignment') dropDownVerticalAlignment: any;
    @Input('enableBrowserBoundsDetection') enableBrowserBoundsDetection: any;
    @Input('enableAbsoluteSelection') enableAbsoluteSelection: any;
    @Input('firstDayOfWeek') firstDayOfWeek: any;
    @Input('formatString') formatString: any;
    @Input('min') min: any;
    @Input('max') max: any;
    @Input('openDelay') openDelay: any;
    @Input('placeHolder') placeHolder: any;
    @Input('popupZIndex') popupZIndex: any;
    @Input('rtl') rtl: any;
    @Input('readonly') readonly: any;
    @Input('showFooter') showFooter: any;
    @Input('selectionMode') selectionMode: any;
    @Input('showWeekNumbers') showWeekNumbers: any;
    @Input('showTimeButton') showTimeButton: any;
    @Input('showCalendarButton') showCalendarButton: any;
    @Input('theme') theme: any;
    @Input('template') template: any;
    @Input('textAlign') textAlign: any;
    @Input('todayString') todayString: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }
}

/**
 * Date Time Input Module
 */
@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgcErrorModule],
    exports: [NgcDateTimeInputComponent],
    declarations: [NgcDateTimeInputComponent, jqxDateTimeInputComponent]
})
export class NgcDateTimeInputModule {
}